<template>
  <div class="OrderServices">
    <a-spin :spinning="spinning">
      <!--  服务详情-->
      <!--  <div v-if="!isShow">-->
      <div>
        <div style="border-bottom: 1px solid #edeff2">
          <div class="moTitle">订购服务</div>
        </div>
        <div class="content">
          <div
            class="nameTime"
            style="display: flex; justify-content: space-between"
          >
            <div>当前版本：{{ systemText }}</div>
            <div>有效期：{{ time }}</div>
          </div>
          <!--      <div class="nameTime">-->
          <!--        <div style="display: flex;width: 17%;">仓库容量<div class="title">5G/年</div></div>-->
          <!--        <a-progress style="width: 70%;" :percent="50" :show-info="false" />-->
          <!--        <div class="capacity">剩余容量3G</div>-->
          <!--      </div>-->
          <!--      <div class="nameTime">-->
          <!--        <div style="display: flex;width: 17%;">短信容量<div class="title">200条/年</div></div>-->
          <!--        <a-progress style="width: 70%" :percent="50" :show-info="false" />-->
          <!--        <div class="capacity">剩余100条</div>-->
          <!--      </div>-->
          <!--      <div class="nameTime">-->
          <!--        <div style="display: flex;width: 17%;">短信容量<div class="title">200条/年</div></div>-->
          <!--        <a-progress style="width: 70%" :percent="50" :show-info="false" />-->
          <!--        <div class="capacity">剩余100条</div>-->
          <!--      </div>-->

          <!--        table-->
          <!--        <div>-->
          <!--          <table class="tableDiv">-->
          <!--            <tr>-->
          <!--              &lt;!&ndash;            <td class="td-left">&ndash;&gt;-->
          <!--              &lt;!&ndash;              <div class="biaotou">&ndash;&gt;-->
          <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;            </td>&ndash;&gt;-->

          <!--              <td class="td tdTitle">-->
          <!--                功能-->
          <!--              </td>-->
          <!--              <td class="td tdTitle">-->
          <!--                详细功能-->
          <!--              </td>-->
          <!--              <td v-for="list in orderServicesData" :class="{backGC:list.name === '免费版',bgImg:list.name === '免费版',titleHd:list.name !== '免费版'}" class="td tdTitle">-->
          <!--                &lt;!&ndash;              <div class="bgImg"></div>&ndash;&gt;-->
          <!--                &lt;!&ndash;              <div style="background-image: url('../../../assets/icon/now.png');"></div>&ndash;&gt;-->
          <!--                {{ list.name }}-->
          <!--              </td>-->
          <!--            </tr>-->
          <!--            &lt;!&ndash;          <tr>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td-left">专享功能</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td" :class="{backGC:currentVersion === 'free'}">免费微网站搭建</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td">包含免费版所有功能，及：会议直播，邀请专家</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td">包含标准版所有功能，及优先审批</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;          </tr>&ndash;&gt;-->
          <!--            &lt;!&ndash;          <tr>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td-left">仓库容量</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td" :class="{backGC:currentVersion === 'free'}">5G/年</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td">50G/年</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td">100G/年</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;          </tr>&ndash;&gt;-->
          <!--            &lt;!&ndash;          <tr>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td-left">短信容量</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td" :class="{backGC:currentVersion === 'free'}">200条/年</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td">500条/年</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td">1500条/年</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;          </tr>&ndash;&gt;-->
          <!--            &lt;!&ndash;          <tr>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td-left">服务</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td" :class="{backGC:currentVersion === 'free'}">无</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <td class="td" colspan="2">专享客服，提供发票与合同</td>&ndash;&gt;-->
          <!--            &lt;!&ndash;          </tr>&ndash;&gt;-->
          <!--            <tr>-->
          <!--              &lt;!&ndash;            <td class="td-left"></td>&ndash;&gt;-->
          <!--              <td class="td"><span class="tdTitle">会议网站</span></td>-->
          <!--              <td class="td"></td>-->
          <!--              <td class="td" v-for="list in orderServicesData" :class="{backGC:list.name === '免费版'}">-->
          <!--                <div>-->
          <!--                  <span class="tdTitle">￥{{list.price}}</span>/年-->
          <!--                </div>-->
          <!--                <a-button v-if="list.name !== '免费版'" style="margin-top: 5px" @click="orderBtn(list)">升级为此版本</a-button>-->
          <!--              </td>-->
          <!--            </tr>-->
          <!--          </table>-->
          <!--        </div>-->

          <div class="blueTable">
            <a-table
              size="small"
              :columns="columns"
              :customHeaderRow="customRow"
              :data-source="data"
              :scroll="{ y: 600 }"
              :pagination="false"
            >
              <!--            <span slot="standardEditionTitle">-->
              <!--              <a-icon type="smile-o" /> 标准版-->
              <!--            </span>-->

              <template slot="standardEdition" slot-scope="text">
                <div v-if="text === '标准版'">
                  <admin_con style="font-size: 25px" type="icon-point-large" />
                </div>
                <div v-else-if="text === ''">--</div>
                <div v-else-if="text === '原价：5999元/年  活动价：4999元/年'">
                  <div class="yuan">原价：599元/月</div>
                  <div>活动价：399元/月</div>
                  <div style="margin-top: 5px">
                    <a-button
                      @click="orderBtn('standard')"
                      style="color: #45a5e6; border: 1px solid #45a5e6"
                      >{{systemText === '免费版' ? '升级为此版本':'续费'}}</a-button
                    >
                  </div>
                </div>
                <div v-else-if="text === '备注'"
                  style="display: flex; justify-content: center"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-right: 10px;
                    "
                  >
                    <admin_con
                      style="font-size: 25px; margin-right: 5px"
                      type="icon-point-large"
                    />
                    必备功能
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    "
                  >
                    <div style="margin-right: 5px">--</div>
                    无
                  </div>
                </div>
                <div v-else-if="text === '按月:5条  按年:不限制'"><span>按月:5条  按年:<span style="color: red">不限制</span></span></div>
                <div v-else class="fontW">{{ text }}</div>
              </template>
              <template slot="FreeEdition" slot-scope="text">
                <div v-if="text === '免费版'">
                  <admin_con style="font-size: 25px" type="icon-point-large" />
                </div>
                <div v-else-if="text === ''">--</div>
                <div
                  v-else-if="text === '备注'"
                  style="display: flex; justify-content: center"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-right: 10px;
                    "
                  >
                    <admin_con
                      style="font-size: 25px; margin-right: 5px"
                      type="icon-point-large"
                    />
                    必备功能
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    "
                  >
                    <div style="margin-right: 5px">--</div>
                    无
                  </div>
                </div>
                <div v-else class="fontW">{{ text }}</div>
              </template>
              <span slot="FreeEditionTitle">
                <span v-if="systemText === '免费版'"
                  >免费版 <a-tag color="orange">当前版本</a-tag></span
                >
                <span v-else>免费版</span>
              </span>
              <span slot="standardEditionTitle">
                <span v-if="systemText === '标准版'"
                  >标准版 <a-tag color="orange">当前版本</a-tag></span
                >
                <span v-else>标准版</span>
              </span>
              <span slot="flagshipVersionTitle">
                <span v-if="systemText === '旗舰版'"
                  >旗舰版 <a-tag color="orange">当前版本</a-tag></span
                >
                <span v-else>旗舰版</span>
              </span>

              <template slot="flagshipVersion" slot-scope="text">
                <span>搭建中 敬请期待111</span>
              </template>
            </a-table>
          </div>
        </div>
        <!--    底部付款按钮-->
        <div v-if="selectOrder">
          <div style="height: 50px"></div>
          <div class="bottomSty">
            <div class="btn">
              <span class="number" style="display: flex; align-items: center"
                ><span>购买时长：</span>
                <span style="font-size: 25px; color: red">
                  <div style="display: flex; align-items: center">

                    <a-radio-group v-model="number" @change="changProduce" size="small">
                      <a-radio-button
                        :value="item.month"
                        v-for="(item, index) in monthArr"
                        :key="index"
                      >
                      {{ item.value }}
                      </a-radio-button>
                    </a-radio-group>


                    <!-- <a-button
                      style="border-radius: unset"
                      :disabled="number === 1"
                      @click="minus"
                      >-</a-button
                    >
                    <a-input-number
                      v-model="number"
                      @change="numberChange"
                      @blur="blur"
                      :min="1"
                    ></a-input-number>
                    <a-button style="border-radius: unset" @click="add"
                      >+</a-button
                    > -->
                  </div></span
                ></span
              >
              <span class="number" style="display: flex;align-items: center;">
                订单总金额
                <span style="font-size: 25px; color: red;margin-left: 6px;">{{ TotalPrice }}元</span>
              </span>
              <div style="display: flex;align-items: center;">
                <a-checkbox :checked="selectAgreement" @change="onChange"
                  >已阅读并同意</a-checkbox
                >
                <a @click="openLink">《医驰企业版服务条款》</a>
                <a-button
                  style="margin-left: 10px"
                  type="primary"
                  @click="submitOrder"
                  >提交订单</a-button
                >
              </div>
            </div>
          </div>
        </div>

        <!--    确认产品信息 v-if="ProductVisible"   :data="ProductInforList" -->
        <!-- <ProductInfor
          v-if="ProductVisible"
          :visible="ProductVisible"
          :orderNumber="orderNumber"
          :publishedConvention="false"
          v-on:closeMainProduct="closeMainProduct"
          v-on:OpenPayModel="OpenPayModel"
      /> -->
        <ProductinforNew
          v-if="ProductVisible"
          :visible="ProductVisible"
          :orderNumber="orderNumber"
          v-on:closeProductinfor="closeProductinfor"
        >
        </ProductinforNew>
        <!--    订单支付  -->
        <pay-indent
          v-if="payVisible"
          :orderNumber="orderNumber"
          :visible="payVisible"
          :publishedConvention="false"
          :isLogInAgain="true"
          v-on:closeMain="closeMainPay"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>
import {
  cancellationOrder,
  companyOrderService,
  getYCompanyService,
  postOrder,
  subscriptionServices,
  unpaidOrder,
  uploadBankReceipt,
  getServiceTimeout,
  serviceMoney,
  postOrderNew,
} from "@/service/authentication";
import { update } from "@/utils/update";
import { admin_icon } from "@/utils/myIcon";
import ProductInfor from "@/components/PaidView/ProductInfor";
import ProductinforNew from "@/components/PaidView/ProductinforNew";
import payIndent from "@/components/PaidView/payIndent";
const renderContent = (text, record, index, columns) => {
  // 检查当前行与前一行的值是否相同
  if (index > 0 && this.data[index - 1][columns] === text) {
    return {
      children: text,
      attrs: { rowSpan: 0 },
    }; // 合并
  }
  // 如果当前单元格是第一个出现的相同内容，则rowSpan设为合并行数
  let rowSpan = 1;
  for (let i = index + 1; i < this.data.length; i++) {
    if (this.data[i][columns] === text) {
      rowSpan++;
    } else {
      break;
    }
  }
  return {
    children: text,
    attrs: { rowSpan },
  };
};
const data = [
  {
    key: "1",
    function: "", //功能
    Details: "", //详细功能
    code: "",
    FreeEdition: "",
    standardEdition: "原价：5999元/年  活动价：4999元/年",
    flagshipVersion: "搭建中 敬请期待",
  },
  //图片展示
  {
    key: "2",
    function: "会议微网站", //功能
    Details: "基础功能类型", //详细功能
    code: "图片展示",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //PDF展示
  {
    key: "3",
    function: "会议微网站", //功能
    Details: "基础功能类型", //详细功能
    code: "PDF展示",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //图文链接展示
  {
    key: "4",
    function: "会议微网站", //功能
    Details: "基础功能类型", //详细功能
    code: "图文链接展示",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //自定义外链
  {
    key: "5",
    function: "会议微网站", //功能
    Details: "基础功能类型", //详细功能
    code: "自定义外链",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //文本编辑
  {
    key: "6",
    function: "会议微网站", //功能
    Details: "基础功能类型", //详细功能
    code: "文本编辑",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //自定义表单字段
  {
    key: "7",
    function: "会议微网站", //功能
    Details: "表单功能", //详细功能
    code: "自定义表单字段",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //表单收集数据导出
  {
    key: "8",
    function: "会议微网站", //功能
    Details: "表单功能", //详细功能
    code: "表单收集数据导出",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //个人报名
  {
    key: "9",
    function: "会议微网站", //功能
    Details: "报名缴费", //详细功能
    code: "个人报名",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //帮他人报名
  {
    key: "10",
    function: "会议微网站", //功能
    Details: "报名缴费", //详细功能
    code: "帮他人报名",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //团体报名
  {
    key: "11",
    function: "会议微网站", //功能
    Details: "报名缴费", //详细功能
    code: "团体报名",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //微信支付
  {
    key: "12",
    function: "会议微网站", //功能
    Details: "报名缴费", //详细功能
    code: "微信支付",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //扫码签到
  {
    key: "13",
    function: "会议微网站", //功能
    Details: "报名缴费", //详细功能
    code: "扫码签到",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //报名记录导出
  {
    key: "14",
    function: "会议微网站", //功能
    Details: "报名缴费", //详细功能
    code: "报名记录导出",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //内部人员管理
  {
    key: "15",
    function: "会议计划", //功能
    Details: "人员管理", //详细功能
    code: "内部人员管理",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //供应商管理
  {
    key: "16",
    function: "会议计划", //功能
    Details: "人员管理", //详细功能
    code: "供应商管理",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //志愿者管理
  {
    key: "17",
    function: "会议计划", //功能
    Details: "人员管理", //详细功能
    code: "志愿者管理",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //选择计划模版
  {
    key: "18",
    function: "会议计划", //功能
    Details: "会议计划", //详细功能
    code: "选择计划模版",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //任务分配
  {
    key: "19",
    function: "会议计划", //功能
    Details: "会议计划", //详细功能
    code: "任务分配",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //进度跟踪
  {
    key: "20",
    function: "会议计划", //功能
    Details: "会议计划", //详细功能
    code: "进度跟踪",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //手机端会务助手
  {
    key: "21",
    function: "会议计划", //功能
    Details: "会议计划", //详细功能
    code: "手机端会务助手",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //住宿安排管理
  {
    key: "22",
    function: "会议计划", //功能
    Details: "会议计划模板", //详细功能
    code: "住宿安排管理",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //会场租赁管理
  {
    key: "23",
    function: "会议计划", //功能
    Details: "会议计划模板", //详细功能
    code: "会场租赁管理",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //接送车辆安排
  {
    key: "24",
    function: "会议计划", //功能
    Details: "会议计划模板", //详细功能
    code: "接送车辆安排",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //物料管理
  {
    key: "25",
    function: "会议计划", //功能
    Details: "会议计划模板", //详细功能
    code: "物料管理",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //设备管理
  {
    key: "26",
    function: "会议计划", //功能
    Details: "会议计划模板", //详细功能
    code: "设备管理",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //同期多会场
  {
    key: "27",
    function: "会务管理", //功能
    Details: "日程管理", //详细功能
    code: "同期多会场",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //批量导入日程
  {
    key: "28",
    function: "会务管理", //功能
    Details: "日程管理", //详细功能
    code: "批量导入日程",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //日程智能纠错
  {
    key: "29",
    function: "会务管理", //功能
    Details: "日程管理", //详细功能
    code: "日程智能纠错",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //批量导入名单
  {
    key: "30",
    function: "会务管理", //功能
    Details: "参会人员", //详细功能
    code: "批量导入名单",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //行程跟踪
  {
    key: "31",
    function: "会务管理", //功能
    Details: "参会人员", //详细功能
    code: "行程跟踪",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //接送安排
  {
    key: "32",
    function: "会务管理", //功能
    Details: "参会人员", //详细功能
    code: "接送安排",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //酒店安排
  {
    key: "33",
    function: "会务管理", //功能
    Details: "参会人员", //详细功能
    code: "酒店安排",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //电子邀请函
  {
    key: "34",
    function: "会务管理", //功能
    Details: "参会人员", //详细功能
    code: "电子邀请函",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //批量短信邀约
  {
    key: "35",
    function: "会务管理", //功能
    Details: "参会人员", //详细功能
    code: "批量短信邀约",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //讲课资料收集
  {
    key: "36",
    function: "会务管理", //功能
    Details: "参会人员", //详细功能
    code: "讲课资料收集",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //桌卡
  {
    key: "37",
    function: "会务管理", //功能
    Details: "电子物料", //详细功能
    code: "桌卡",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //胸卡
  {
    key: "38",
    function: "会务管理", //功能
    Details: "自动生成", //详细功能
    code: "胸卡",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //设置主办单位
  {
    key: "39",
    function: "增值服务", //功能
    Details: "微网站", //详细功能
    code: "设置主办单位",
    FreeEdition: "99元/条", //1代表空，2代表免费，3代表--，4代表
    // standardEdition: "标准版",
    standardEdition: "按月:5条  按年:不限制",
    flagshipVersion: "搭建中 敬请期待",
  },
  //去除首页平台标识
  {
    key: "40",
    function: "增值服务", //功能
    Details: "微网站", //详细功能
    code: "去除首页平台标识",
    FreeEdition: "99元/条", //1代表空，2代表免费，3代表--，4代表
    // standardEdition: "标准版",
    standardEdition: "按月:5条  按年:不限制",
    flagshipVersion: "搭建中 敬请期待",
  },
  //案例展示
  {
    key: "41",
    function: "增值服务", //功能
    Details: "微网站", //详细功能
    code: "案例展示",
    FreeEdition: "19.9元/条", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //模版1
  {
    key: "42",
    function: "增值服务", //功能
    Details: "微网站首页模板", //详细功能
    code: "模版1",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //模版2
  {
    key: "43",
    function: "增值服务", //功能
    Details: "微网站首页模板", //详细功能
    code: "模版2",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //模版3
  {
    key: "44",
    function: "增值服务", //功能
    Details: "微网站首页模板", //详细功能
    code: "模版3",
    FreeEdition: "119元/条", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "119元/条",
    flagshipVersion: "搭建中 敬请期待",
  },
  //模版4
  {
    key: "45",
    function: "增值服务", //功能
    Details: "微网站首页模板", //详细功能
    code: "模版4",
    FreeEdition: "119元/条", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "119元/条",
    flagshipVersion: "搭建中 敬请期待",
  },
  //适量图标
  {
    key: "46",
    function: "增值服务", //功能
    Details: "微网站首页功能", //详细功能
    code: "适量图标",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //城市图标
  {
    key: "47",
    function: "增值服务", //功能
    Details: "图标", //详细功能
    code: "城市图标",
    FreeEdition: "免费版", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //短信包
  {
    key: "48",
    function: "增值服务", //功能
    Details: "短信", //详细功能
    code: "短信包",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "",
    flagshipVersion: "搭建中 敬请期待",
  },
  //自定义短信标签
  {
    key: "49",
    function: "增值服务", //功能
    Details: "短信", //详细功能
    code: "自定义短信标签",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  //邮件包
  {
    key: "50",
    function: "增值服务", //功能
    Details: "邮件", //详细功能
    code: "邮件包",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "",
    flagshipVersion: "搭建中 敬请期待",
  },
  //自定义邮件签名
  {
    key: "51",
    function: "增值服务", //功能
    Details: "邮件", //详细功能
    code: "自定义邮件签名",
    FreeEdition: "", //1代表空，2代表免费，3代表--，4代表
    standardEdition: "标准版",
    flagshipVersion: "搭建中 敬请期待",
  },
  {
    key: "52",
    function: "", //功能
    Details: "", //详细功能
    code: "",
    FreeEdition: "备注",
    standardEdition: "备注",
    flagshipVersion: "搭建中 敬请期待",
  },
];

export default {
  name: "OrderServices",
  components: {
    admin_con: admin_icon,
    ProductInfor,
    payIndent,
    ProductinforNew,
  },
  data() {
    const columns = [
      {
        title: "功能",
        dataIndex: "function",
        width: "15%",
        align: "center",
        customRender: (text, record, index) => {
          // 检查当前行与前一行的值是否相同
          if (index > 0 && this.data[index - 1].function === text) {
            return {
              children: text,
              attrs: { rowSpan: 0 },
            }; // 合并
          }
          // 如果当前单元格是第一个出现的相同内容，则rowSpan设为合并行数
          let rowSpan = 1;
          for (let i = index + 1; i < this.data.length; i++) {
            if (this.data[i].function === text) {
              rowSpan++;
            } else {
              break;
            }
          }
          return {
            children: text,
            attrs: { rowSpan },
          };
        },
        scopedSlots: { customRender: "function" },
      },

      {
        title: "详细功能",
        colSpan: 2,
        dataIndex: "Details",
        width: "20%",
        align: "center",
        customRender: (text, record, index) => {
          // 检查当前行与前一行的值是否相同
          if (index > 0 && this.data[index - 1].Details === text) {
            return {
              children: text,
              attrs: { rowSpan: 0 },
            }; // 合并
          }
          // 如果当前单元格是第一个出现的相同内容，则rowSpan设为合并行数
          let rowSpan = 1;
          for (let i = index + 1; i < this.data.length; i++) {
            if (this.data[i].Details === text) {
              rowSpan++;
            } else {
              break;
            }
          }
          return {
            children: text,
            attrs: { rowSpan },
          };
        },
      },
      {
        title: "code",
        dataIndex: "code",
        colSpan: 0,
        align: "center",
        width: "20%",
      },

      {
        // title: '免费版',
        width: "15%",
        align: "center",
        dataIndex: "FreeEdition",
        slots: { title: "FreeEditionTitle" },
        scopedSlots: { customRender: "FreeEdition" },
      },
      {
        // title: '标准版',
        width: "15%",
        align: "center",
        dataIndex: "standardEdition",
        slots: { title: "standardEditionTitle" },
        scopedSlots: { customRender: "standardEdition" },
      },
      {
        // title: '旗舰版',
        width: "15%",
        align: "center",
        dataIndex: "flagshipVersion",
        slots: { title: "flagshipVersionTitle" },
        scopedSlots: { customRender: "flagshipVersion" },
        // customRender: (text, record, index) => {
        //   // 检查当前行与前一行的值是否相同
        //   if (index > 0 && this.data[index - 1].flagshipVersion === text) {
        //     return {
        //       children: text,
        //       attrs: { rowSpan: 0 }
        //     }; // 合并
        //   }
        //   // 如果当前单元格是第一个出现的相同内容，则rowSpan设为合并行数
        //   let rowSpan = 1;
        //   for (let i = index + 1; i < this.data.length; i++) {
        //     if (this.data[i].flagshipVersion === text) {
        //       rowSpan++;
        //     } else {
        //       break;
        //     }
        //   }
        //   return {
        //     children: text,
        //     attrs: { rowSpan }
        //   };
        // }

        customRender: (text, record, index) => {
          if (index === 0 || this.data[index - 1].flagshipVersion !== text) {
            let rowSpan = 1;
            for (let i = index + 1; i < this.data.length; i++) {
              if (this.data[i].flagshipVersion === text) {
                rowSpan++;
              } else {
                break;
              }
            }
            return {
              children: (
                <span
                  style={{
                    writingMode: "vertical-rl",
                    transform: "rotate(0)",
                    textAlign: "center", // 居中显示
                    whiteSpace: "nowrap", // 防止文字换行
                    display: "inline-block",
                    letterSpacing: "5px", // 设置字间距
                    fontSize: "20px",
                  }}
                >
                  {text}
                </span>
              ),
              attrs: { rowSpan, colSpan: 1 }, // 确保 colSpan 为 1
            };
          } else {
            return {
              children: text,
              attrs: { rowSpan: 0, colSpan: 1 },
            };
          }
        },
      },
    ];
    return {
      number: 1,
      monthArr: [
        {
          value: '1月',
          month: 1
        },
        {
          value: '2月',
          month: 2
        },
        {
          value: '3月',
          month: 3
        },
        {
          value: '4月',
          month: 4
        },
        {
          value: '5月',
          month: 5
        },
        {
          value: '6月',
          month: 6
        },
        {
          value: '7月',
          month: 7
        },
        {
          value: '8月',
          month: 8
        },
        {
          value: '9月',
          month: 9
        },
        {
          value: '10月',
          month: 10
        },
        {
          value: '11月',
          month: 11
        },
        {
          value: '1年',
          month: 12
        },
        {
          value: '2年',
          month: 24
        },
      ],
      spinning: false,
      days: 0,
      isShow: 0,
      data,
      columns,
      currentVersion: "free", //free 免费
      orderServicesData: [],
      selectOrder: false,
      selectOrderList: [],
      selectAgreement: false,
      orderInfo: {},
      // bankReceipt:'',
      systemText: "",
      ProductVisible: false,
      orderNumber: "",
      payVisible: false,
      time: "",
      TotalPrice: 0,
    };
  },
  mounted() {
    // this.startCountdown();
    // setInterval(this.startCountdown, 1000);
  },
  created() {
    this.getSystemText();
    this.getSubscriptionServices();
    this.getTimeOut();
    this.Money();
  },
  computed: {},
  methods: {
    async getTimeOut() {
      const res = await getServiceTimeout();
      if (res.code == 200) {
        this.time = res.data.time;
      }
    },
    closeMainPay(val) {
      this.payVisible = val;
    },
    OpenPayModel() {
      this.payVisible = true;
    },
    closeProductinfor(val) {
      this.ProductVisible = val;
      // this.getList();
    },
    //获取系统版本名称
    async getSystemText() {
      const response = await getYCompanyService();
      if (response.code === 200) {
        this.systemText = response.data;
      }
    },
    customRow(column) {
      // console.log(conlumn); // 在这里可以在控制台看到有一个className ，如下图
      column.forEach((e, index) => {
        column[index].className = "tableClass"; // 给数组中的每一列加上一个类名
      });
    },
    //获取订购服务列表
    async getSubscriptionServices() {
      this.spinning = true;
      const response = await subscriptionServices();
      if (response.code === 0) {
        // this.isShow = response.isShow;
        // if(response.isShow === 0){ //没有订单
        this.orderServicesData = response.data;
        // }else {
        //   //有订单未支付
        //   await this.getUnpaidOrder();
        // }
        //倒计时
        this.startCountdown();
        setInterval(this.startCountdown, 1000);
      } else {
        this.$message.warning(response.message);
      }
      this.spinning = false;
    },

    async getUnpaidOrder() {
      const response = await unpaidOrder();
      if (response.code === 0) {
        this.data = [response.data];
        this.orderInfo = response.data;
      } else {
        this.$message.warning(response.message);
      }
    },
    //倒计时
    startCountdown() {
      const now = new Date().getTime();
      let payDate = this.orderInfo.orderTime;
      // 获取当前时间
      const currentDate = new Date(payDate);
      // 添加14天
      currentDate.setDate(currentDate.getDate() + 14);
      // 获取14天后的时间
      const futureDate = currentDate;

      const distance = futureDate.getTime() - now;

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
    },
    async uploadImg() {
      let inputDOM = this.$refs.uploadImg.files[0];
      //判断图片大小
      // if (inputDOM.size < 1048576) {
      const image = await update(inputDOM);
      if (image.code === 0) {
        // this.bankReceipt = image.data.url;
        let data = {
          id: this.orderInfo.id, //订单id
          bankReceipt: image.data.url, //银行回执单图片
        };
        await this.upBankReceipt(data);
      } else {
        this.$message.warning("上传失败");
      }
      // } else {
      //   this.$message.warning("请上传小于1M的图片！");
      // }
      document.getElementById("uploadImgId").value = null;
    },
    //上传银行回执
    async upBankReceipt(data) {
      const response = await uploadBankReceipt(data);
      if (response.code === 200) {
        //刷新
        await this.getSubscriptionServices();
        this.$message.success("上传成功");
      } else {
        this.$message.warning(response.message);
      }
    },
    cancelOrder() {
      //取消订单
      let data = {
        id: this.orderInfo.id,
      };
      this.putAncellationOrder(data);
    },
    async putAncellationOrder(data) {
      const response = await cancellationOrder(data);
      if (response.code === 200) {
        this.$message.success("订单已取消！");
        await this.getSubscriptionServices();
      } else {
        this.$message.warning(response.message);
      }
    },
    orderBtn(code) {
      let row = {
        price: 4999,
        code: code,
        name: code === "standard" ? "升级为标准版" : "",
      };
      this.selectOrder = true;
      this.selectOrderList = row;
    },
    //获取账号未付款的订单信息
    async submitOrder() {
      if (this.selectAgreement) {
        //已勾选
        // let data = {
        //   "orderType": "订购服务",
        //   "orderMoney": this.selectOrderList.price,
        //   "serviceCode": this.selectOrderList.code,
        //   "serviceName": this.selectOrderList.name
        // }
        // this.order(data);

        const response = await postOrderNew(this.number, "standard");
        if (response.code === 200) {
          this.orderNumber = response.data;
          this.ProductVisible = true;
        } else {
          this.$message.warning(response.message);
        }
      } else {
        this.$message.warning("请阅读并勾选医驰企业版服务条款！");
      }
    },
    openLink() {
      window.open("../userAg.html");
    },
    async order(data) {
      const response = await postOrder(data);
      if (response.code === 200) {
        this.$message.success("提交成功！");
        await this.getSubscriptionServices();
        this.selectAgreement = false;
        this.selectOrder = false;
        // this.isShow = true;
      } else {
        this.$message.warning(response.message);
      }
    },
    onChange(e) {
      this.selectAgreement = e.target.checked;
    },
    add() {
      this.number++;
      this.Money();
    },
    minus() {
      this.number--;
      this.Money();
    },
    async Money() {
      const res = await serviceMoney(this.number, "standard");
      this.TotalPrice = res.data.discountPrice;
    },
    numberChange(e) {
      this.Money();
      // console.log(e.target.value);
    },
    changProduce(){
      this.Money();
    },
    blur() {
      if (!this.number) {
        this.number = 1;
        this.Money();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fontW {
  font-weight: bold;
}

.blueTable {
  ::v-deep.tableClass {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    background: #cccccc !important;
    font-size: 18px;
  }
  ::v-deep
    .ant-table-small
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body
    > table
    > .ant-table-tbody
    > tr
    > td {
    font-weight: bold;
  }
  ::v-deep .ant-table-thead > tr > th {
    font-weight: bold;
  }
  ::v-deep
    .ant-table-small
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body
    > table
    > .ant-table-thead
    > tr {
    background-color: #9bc2e6;
  }
  //font-size: 16px!important;
  font-weight: bold;
  color: #333333;
  .yuan {
    font-weight: normal;
    text-decoration: line-through;
    font-size: 12px;
    color: #929292;
  }
}
/* 定义表头的加粗样式 */
.ant-table-thead th {
  font-weight: bold;
  font-size: 16px;
  background-color: #45a5e6;
}
.OrderServices {
  border: 10px solid #edeff2;
  .moTitle {
    display: flex;
    justify-content: space-between;
    width: 98%;
    margin: auto;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
    color: $topTitleColor;
  }
  .content {
    margin: 30px;
    .nameTime {
      display: flex;
      margin-bottom: 20px;
      color: #333333;
      font-size: 16px;
      .title {
        margin-left: 20px;
        width: 100px;
      }
      .capacity {
        width: 13%;
        text-align: right;
        //margin-left:30px;
      }
    }
  }
  .tableDiv {
    width: 100%;
    .bgImg {
      background-image: url("../../../assets/icon/now.png");
      background-repeat: no-repeat;
      background-size: 40.5px 34.5px;
    }
    .backGC {
      background-color: rgb(205, 230, 240);
    }
    .td-left {
      width: 200px;
      //height:50px;
      background-color: #fff;
      text-align: center;
      border: 1px solid #e5e4e4;
    }
    .td {
      width: 10%;
      height: 80px;
      text-align: center;
      border: 1px solid #e5e4e4;
    }
    .tdTitle {
      font-size: 18px;
      font-weight: bold;
    }
    .titleHd {
      background-color: #e0dede;
    }
    .biaotou {
      width: 200px;
      height: 100px;
      background: linear-gradient(
        to top right,
        transparent 0%,
        transparent calc(50% - 1px),
        #d9d7d7 50%,
        transparent calc(50% + 1px),
        transparent 100%
      );
    }
  }
  .bottomSty {
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    z-index: 9;
    background-color: #f0f2f5;
    border-bottom: 1px solid #fff;
    .btn {
      width: 83%;
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
  }
  .number {
    font-size: 16px;
    margin-left: 25px;
  }
}
.card {
  width: 98%;
  padding: 20px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 300px;
  border: 1px solid #edeff2;
  box-shadow: 1px 1px 15px #d7d7d7;
  .cardTop {
    .topTitle {
      font-weight: 600;
      color: $topTitleColor;
    }
    margin-bottom: 20px;
    margin-top: 10px;
    .cardTop-font {
      margin-left: 50px;
      margin-right: 50px;
    }
  }
  .payCard {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .vertical-header {
    writing-mode: vertical-rl; /* 设置文字竖直显示 */
    text-align: center; /* 设置文字居中对齐 */
    transform: rotate(180deg); /* 可选：让文字从上到下显示 */
  }
}
::v-deep .ant-input-number-handler-wrap {
  display: none;
}

::v-deep .ant-input-number-input {
  text-align: center !important;
  //  border-right: none !important;
  //  border-left: none !important;
  //  width: 40px !important;
  //  border-radius: 110px;
}

::v-deep .ant-radio-group-small .ant-radio-button-wrapper {
    height: 34px;
    padding: 0px 9px;
    line-height: 34px;
}
</style>
